import React from 'react';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Paper from '@mui/material/Paper';

// Type pour l'objet retourné par onChange
export type QuestionBoolChangeEvent = {
  code: string;
  position: number;
  legende: string;
  value: string;
  libelle: string;
};

type Props = {
  legende: string;
  qualificationDetailCode: string;
  value: string | null;
  position?: number;
  onChange: (changeEvent: QuestionBoolChangeEvent) => void;
  required?: boolean;
};

/**
 * Composant réutilisable pour les questions booléennes (Oui/Non)
 *
 * @param {string} legende - Le texte de la question
 * @param {string} qualificationDetailCode - Le code de qualification
 * @param {string | null} value - La valeur actuelle ("0", "1" ou "")
 * @param {number} position - La position du détail de qualification
 * @param {function} onChange - Fonction de callback pour les changements
 * @param {boolean} required - Si la question est obligatoire
 */
function QuestionBooleenne({legende, qualificationDetailCode, value, position = 0, onChange, required = false}: Props)  {
  // Fonction qui convertit l'événement React en objet personnalisé
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    const libelle = newValue === "true" ? "Oui" : "Non";
    
    onChange({
      code: qualificationDetailCode,
      position: position,
      legende: legende,
      value: newValue,
      libelle: libelle
    });
  };
  return (
    <Paper
      sx={{
        width: '100%',
        mb: 2
      }}
    >
      <Box sx={{ p: 2 }}>
        <FormControl
          component="fieldset"
          required={required}
          fullWidth
        >
          <FormLabel component="legend" sx={{ mb: 1 }}>{legende}</FormLabel>
          <RadioGroup
            id={qualificationDetailCode}
            name={qualificationDetailCode}
            value={value}
            onChange={handleChange}
            sx={{ ml: 2 }}
          >
            <FormControlLabel value="true" control={<Radio />} label="Oui" sx={{ height: '30px' }} />
            <FormControlLabel value="false" control={<Radio />} label="Non" sx={{ height: '30px' }} />
          </RadioGroup>
        </FormControl>
      </Box>
    </Paper>
  );
}

export default QuestionBooleenne;